import {
  WISHLIST_TOGGLE_PRODUCT,
  WISHLIST_SET_EMAIL,
  WISHLIST_SEND_TO_EMAIL,
  WISHLIST_SHOW_EMAIL_FORM,
  WISHLIST_HIDE_EMAIL_FORM
} from "../../store/constants/hwk";

const initialState = {
  products: [],
  emailForm: {
    email: null,
    visible: false,
    isRequesting: false
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case WISHLIST_TOGGLE_PRODUCT:
      let wishlistProducts = state.products.slice();

      if (wishlistProducts.includes(action.productSku)) {
        wishlistProducts = wishlistProducts.filter(
          (sku, index) => sku !== action.productSku
        );
      } else {
        wishlistProducts.push(action.productSku);
      }

      return {
        ...state,
        products: wishlistProducts
      };

    case WISHLIST_SET_EMAIL:
      return {
        ...state,
        emailForm: {
          ...state.emailForm,
          email: action.email
        }
      };

    case WISHLIST_SEND_TO_EMAIL:
      return {
        ...state,
        emailForm: {
          ...state.emailForm,
          isRequesting: true
        }
      };

    case WISHLIST_SHOW_EMAIL_FORM:
      return {
        ...state,
        emailForm: {
          ...state.emailForm,
          visible: true,
          isRequesting: false
        }
      };

    case WISHLIST_HIDE_EMAIL_FORM:
      return {
        ...state,
        emailForm: {
          ...state.emailForm,
          email: null,
          visible: false,
          isRequesting: false
        }
      };
    default:
      return state;
  }
}
